import React from 'react';

interface FileInfoDisplayProps {
  fileName: string;
  isLoading?: boolean;
}

export function FileInfoDisplay({ fileName, isLoading = false }: FileInfoDisplayProps) {
  const displayFileName = isLoading ? "Processando..." : (fileName || "Processando...");

  return (
    <div className="bg-gradient-to-r from-navy-700/40 to-navy-600/20 rounded-lg p-3 border border-navy-600/30">
      <div className="flex flex-col space-y-1">
        <span className="text-xs text-gray-400 font-medium">Nome do Arquivo:</span>
        <span className="text-sm text-white font-semibold overflow-hidden text-ellipsis break-all leading-tight">
          {displayFileName}
        </span>
      </div>
    </div>
  );
}